class Regions {
  constructor(_id, cityId, city, state, imageURL, industries, individuals, contact) {
    this._id = _id;
    this.cityId = cityId;
    this.city = city;
    this.state = state;
    this.imageURL = imageURL;
    this.industries = industries;
    this.individuals = individuals;
    this.contact = contact;
  }
}

module.exports = Regions;